<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('bulletin.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'bulletins' }">{{ $t('bulletin.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <bulletin-info :bulletin="bulletin"></bulletin-info>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'

import BulletinInfo from '@/components/info/BulletinInfo'

import i18n from '@/plugins/i18n.js'

import BulletinApiService from '@/services/budaedu-api-services/bulletin-api-service.js'

Vue.use(BreadcrumbPlugin)

Vue.use(BulletinApiService)

export default {
  i18n,
  name: 'bulletin',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      title: '',
      bulletin: {}
    }
  },
  methods: {
    async setBulletin() {
      let item = await this.$bulletinApiService.getById(this.id, 'include=attachments')
      this.bulletin = item.data
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`)
    await this.setBulletin()
  },
  components: {
    BulletinInfo
  },
  metaInfo() {
    const title = this.bulletin ? this.bulletin.title : this.$t('bulletin.title')
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>